import React from "react";
import { useNavigate } from "react-router-dom";
import MusicForm from "../../components/discography/MusicForm";
import { useDiscography } from "../../services/admin/DiscographyServices";
import { ChevronLeft } from "lucide-react";

export default function AddMusicPage() {
    const navigate = useNavigate();
    const { createMusic, loading } = useDiscography();


    const handlePublish = async (formData) => {
        const res = await createMusic(formData);
        if (res.status === "success") {
            navigate("/admin/discography");
        }
    };

    return (
        <div className="p-6 lg:p-10 max-w-5xl mx-auto">
            {/* Navigation Header */}
            <button
                onClick={() => navigate("/admin/discography")}
                className="flex items-center gap-2 text-black dark:text-white/40 hover:text-black/70 dark:hover:text-white transition-colors text-xs font-bold tracking-widest uppercase mb-6"
            >
                <ChevronLeft size={16} /> BACK TO DISCOGRAPHY
            </button>

            <div className="mb-10">
                <h1 className="text-3xl lg:text-4xl font-normal text-black dark:text-white mb-2" style={{ fontFamily: "Playfair Display, serif" }}>
                    Add New Music
                </h1>
                <p className="text-black dark:text-white/50 text-sm italic font-serif">
                    Fill in the details below to add a new release to your catalog.
                </p>
            </div>

            {/* Form */}
            <MusicForm
                onSubmit={handlePublish}
                isLoading={loading}
            />
        </div>
    );
}
